import {Component, OnInit} from '@angular/core';
import {switchMap} from "rxjs/operators";
import {from} from "rxjs";
import {saveAs} from "file-saver";
import {HttpErrorResponse} from "@angular/common/http";
import {ActivatedRoute, Router} from "@angular/router";
import {Contract} from "../../../classes/contract";
import {ContractService} from "../../../services/contract";
import {ReportService} from "../../../services/report";

@Component({
    selector: 'app-contract-report',
    templateUrl: './contract-report.component.html',
    styleUrls: ['./contract-report.component.css']
})
export class ContractReportComponent implements OnInit {
    loadingOverlay = false;

    contracts: Array<Contract> = [];
    contractSelected: number | null = null;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private contractService: ContractService,
                private reportService: ReportService) {
    }

    ngOnInit(): void {
        this.contractService.getAllValidated()
            .pipe(
                switchMap((contractsData: any) => from(contractsData))
            )
            .subscribe({
                next: (contract: any) => {
                    this.contracts.push(contract);
                },
                error: e => {
                    console.log('Error: ' + e);
                }
            });
    }

    openGenerateReport() {
        this.loadingOverlay = true;
        this.route.paramMap.subscribe(params => {
            this.reportService.create(this.contractSelected!.toString(), this.contracts.find((contract: Contract) => contract.id_contract === this.contractSelected)!.fk_id_checklist.toString())
                .subscribe({
                    next: (blobFile) => {
                        const fileName = this.contracts.find((contract: Contract) => contract.id_contract === this.contractSelected)!.name;
                        saveAs(blobFile, fileName);
                        this.loadingOverlay = false;
                    },
                    error: (err: HttpErrorResponse) => {
                        console.log(err);
                        this.loadingOverlay = false;
                    }
                });
        });
    }

    openGenerateXLSReport() {
        this.loadingOverlay = true;
        this.route.paramMap.subscribe(params => {
            this.reportService.createXLS(this.contractSelected!.toString(), this.contracts.find((contract: Contract) => contract.id_contract === this.contractSelected)!.fk_id_checklist.toString())
                .subscribe({
                    next: (blobFile) => {
                        const fileName = this.contracts.find((contract: Contract) => contract.id_contract === this.contractSelected)!.name;
                        saveAs(blobFile, fileName);
                        this.loadingOverlay = false;
                    },
                    error: (err: HttpErrorResponse) => {
                        console.log(err);
                        this.loadingOverlay = false;
                    }
                });
        });
    }
}
